import { dynamicLoader } from '~/utils';

export const DtoManyToManyGrid = dynamicLoader({
  name: 'DtoManyToManyGrid',
  importFunc: () => import('./dto-many-to-many-grid'),
});